export default __webpack_public_path__ + "static/media/analyzeRTC.89dd8a02.svg";